"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useDebounce = require("use-debounce");

var _Fab = _interopRequireDefault(require("@mui/material/Fab"));

var _Box = _interopRequireDefault(require("@mui/material/Box"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Grow = _interopRequireDefault(require("@mui/material/Grow"));

var _List = _interopRequireDefault(require("@mui/icons-material/List"));

var _CheckCircle = _interopRequireDefault(require("@mui/icons-material/CheckCircle"));

var _reactI18next = require("react-i18next");

var _Place = _interopRequireDefault(require("@mui/icons-material/Place"));

var Navigation = function Navigation(_ref) {
  var type = _ref.type,
      onClick = _ref.onClick,
      title = _ref.title;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      scrollState = _useState2[0],
      setScrollState = _useState2[1]; // TODO: Calculate using media queries


  var ref = (0, _react.useRef)(null);
  var textRef = (0, _react.useRef)(null);

  var handler = function handler() {
    if (window.scrollY > 30) {
      setScrollState(false);

      if (textRef !== null && textRef !== void 0 && textRef.current) {
        textRef.current.style.display = 'none';
      }
    } else {
      if (textRef !== null && textRef !== void 0 && textRef.current) {
        textRef.current.style.display = 'block';
      }

      setScrollState(true);
    }

    ref.current.style.top = "".concat(window.scrollY + window.innerHeight - 128, "px");
  };

  (0, _react.useEffect)(function () {
    /* eslint-disable no-restricted-globals */
    addEventListener('scroll', handler);
    ref.current.style.top = "".concat(window.scrollY + window.innerHeight - 128, "px"); // ref.current.animate({scrollTop: window.scrollY})
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    ref: ref,
    sx: {
      position: 'absolute',
      right: 16
    }
  }, /*#__PURE__*/_react.default.createElement(_Fab.default, {
    variant: "extended",
    color: "primary",
    "aria-label": t(title),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Grow.default, {
    in: scrollState
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    sx: {
      ml: 1,
      mr: 1
    },
    ref: textRef
  }, " ", t(title), " ")), type === 'choose' && /*#__PURE__*/_react.default.createElement(_Place.default, null), type === 'done' && /*#__PURE__*/_react.default.createElement(_CheckCircle.default, null)));
};

exports.Navigation = Navigation;